'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports['default'] = TitleArea;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _fecha = require('fecha');

var _fecha2 = _interopRequireDefault(_fecha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function TitleArea(p) {

    var propTypes = {
        planData: _react.PropTypes.object,
        period: _react.PropTypes.string,
        onPeriodSwitch: _react.PropTypes.func
    };

    var today = new Date();
    var paymentStartDate = new Date(today.setMonth(today.getMonth() + 1));
    var formattedStartDate = _fecha2['default'].format(paymentStartDate, 'MMM Do, YYYY');

    var cost = void 0,
        shortPeriod = void 0,
        switchText = void 0;
    if (p.period === 'M') {
        cost = p.planData.monthly_price;
        shortPeriod = 'mo';
        switchText = 'Switch to annual plan and save 20%';
    } else {
        cost = p.planData.annual_price;
        shortPeriod = 'yr';
        switchText = 'Switch to monthly plan';
    }

    var mainText = 'Start your risk-free trial';
    var subText = 'Your 30-day trial starts today. Cancel your account anytime. You\'ll be billed $' + cost + '/' + shortPeriod + ' starting ' + formattedStartDate;

    var switchHandler = function switchHandler(e) {
        e.preventDefault();

        if (p.onPeriodSwitch) {
            p.onPeriodSwitch();
        }
    };

    return _react2['default'].createElement(
        'div',
        { className: 'main-title' },
        _react2['default'].createElement(
            'h1',
            null,
            mainText
        ),
        _react2['default'].createElement(
            'h2',
            null,
            subText
        ),
        _react2['default'].createElement(
            'a',
            { onClick: switchHandler },
            switchText
        )
    );
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/pricing/payment-page/title-area.jsx
 ** module id = 1100
 ** module chunks = 0
 **/